import { useApolloClient, useMutation } from '@apollo/client'

import { SignOutDocument } from '@/graphql/purchase-plus/generated/signOut.generated'
import { BROADCAST_LOGGED_OUT_CHANNEL } from '@/modules/shared/broadcast-channels'
import { ENTERPRISE_SIGN_IN_PAGE, PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'
import { useBroadcastChannel } from '@/modules/shared/hooks/useBroadcastChannel'

export default function useSignOut() {
  const apolloClient = useApolloClient()
  const { postMessage: notifyLoggedOut } = useBroadcastChannel(BROADCAST_LOGGED_OUT_CHANNEL)

  const clearCacheAndGoHome = async () => {
    // Purge persisted cache data before clearing store
    window.dispatchEvent(new Event('purgeApolloPersistor'))
    // Small delay to ensure purge completes before navigation
    await new Promise((resolve) => setTimeout(resolve, 100))
    await apolloClient.clearStore()
    window.location.href = ENTERPRISE_SIGN_IN_PAGE
    notifyLoggedOut(true)
  }

  const mutation = useMutation(SignOutDocument, {
    context: { uri: PURCHASE_PLUS_GRAPHQL_API },
    variables: {
      input: {},
    },
    onCompleted() {
      clearCacheAndGoHome()
    },
    onError() {
      // If mutation fails, still clear cache and navigate to root.
      clearCacheAndGoHome()
    },
  })

  return mutation
}
